import React from 'react';
import { CategoryItem } from '../../types/customReport';
import { KText } from '@/ui-library/components/text';
export const ReportCategoriesContainer = ({
  categories,
  categoryOnClick,
}: {
  categories: CategoryItem[];
  categoryOnClick: (category: CategoryItem) => void;
}) => {
  return (
    <div>
      {categories?.map((category) => (
        <KText
          onClick={() => categoryOnClick(category)}
          key={category.id}
          p="10px"
          fontWeight={category.active ? '750' : '450'}
          background={category.active ? 'ats-tertiary' : 'transparent'}
          color="secondary-900"
          borderRadius={'8px'}
          fontSize="14px"
          cursor="pointer"
          _hover={{ background: 'ats-tertiary', fontWeight: '700' }}
        >
          {category.label}
        </KText>
      ))}
    </div>
  );
};
